import { useNavigate, useParams, Link } from "react-router-dom";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import Spacer from "./Spacer";
import Visibility from "./utils/Visibility";
import { indexStore } from "../store/indexStore";
import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import { Skeleton } from "./ui/skeleton";
import RestaurantModel from "../Models/RestaurantModel";

type HeaderProps = {
  noBack?: boolean;
  backgroundColorfull?: boolean;
  url?: string;
  
};
export const Header = ({ noBack = false, ...props }: HeaderProps) => {
  // ...
  const [scroll, setScroll] = useState(false);
  const {
    name,
    restaurant,
    loading,
    // lang, changeLangBottomSheet
  } = indexStore();
  // const { t } = useTranslation();

  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    window.addEventListener("scroll", () => {});
    const handleScroll = () => {
      setScroll(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`flex items-center w-full p-3 md:p-4 bg-background z-50 sticky shrink-0 top-0 transition-all duration-300 ${
        scroll
          ? "shadow-md border-b border-border/50 backdrop-blur-sm bg-background/95"
          : ""
      } ${
        props.backgroundColorfull
          ? "bg-primary text-onPrimary shadow-none border-none"
          : ""
      }`}
    >
      {/* Back Button (Left side) */}
      <Visibility visible={!noBack}>
        <button
          className={`p-2 rounded-lg text-lg cursor-pointer transition-all duration-300 hover:bg-muted/50 active:scale-95 ${
            props.backgroundColorfull
              ? "text-onPrimary hover:bg-onPrimary/10"
              : "text-foreground hover:bg-muted"
          }`}
          onClick={() => {
            if (props.url) {
              return navigate(props.url);
            } else navigate(-1);
          }}
        >
          {localStorage.getItem("Lang") === "ar" ? (
            <FaAngleRight className="w-5 h-5 md:w-6 md:h-6" />
          ) : (
            <FaAngleLeft className="w-5 h-5 md:w-6 md:h-6" />
          )}
        </button>
      </Visibility>
      <Visibility visible={noBack}>
        <Spacer width={18} />
      </Visibility>

      {/* Centered Link (Middle element) */}
      <Visibility visible={!loading}>
        <Link
          className={`font-bold text-lg md:text-xl flex-grow uppercase tracking-wider text-center transition-colors duration-300 hover:opacity-80 ${
            props.backgroundColorfull
              ? "text-onPrimary"
              : "text-primary hover:text-primary/80"
          }`}
          to={`/${params.domain}/${params.branch_id}`}
        >
          {restaurant[name as keyof RestaurantModel]}
        </Link>
      </Visibility>

      <Visibility visible={loading}>
        <div className="flex flex-grow items-center justify-center">
          <Skeleton className="w-1/2 h-7 md:h-8" />
        </div>
      </Visibility>

      <Visibility visible={noBack}>
        <Spacer width={30} />
      </Visibility>
      {/* <SideSheet backgroundColorfull={props.backgroundColorfull} /> */}
    </div>
  );
};
